module.exports = __webpack_public_path__ + "91f3337ac4846f3ed3271e958703372b.svg";